module.exports = __webpack_public_path__ + "img/bank-delete-transaction-disabled.6fbb8a05.svg";